import api from '@/lib/api/axios'
import type { Team } from '@/types/entities'
import type { ListParams, PaginatedResponse } from '@/lib/api/types'

/** Team task row (Mobilisation or Technical checklist) - no MainContact in UI/API */
export interface TeamTaskRow {
    id?: number
    taskNo: number
    task: string
}

export const teamsApi = {
    list: (params?: ListParams) =>
        api.get<PaginatedResponse<Team>>('/api/teams', { params }),

    get: (id: number) =>
        api.get<Team>(`/api/teams/${id}`),

    create: (data: Omit<Team, 'id' | 'createdAt' | 'updatedAt'>) =>
        api.post<Team>('/api/teams', data),

    update: (id: number, data: Partial<Omit<Team, 'id' | 'createdAt' | 'updatedAt'>>) =>
        api.put<Team>(`/api/teams/${id}`, data),

    delete: (id: number) =>
        api.delete(`/api/teams/${id}`),

    getMobilisationTasks: (teamId: number) =>
        api.get<{ data: TeamTaskRow[] }>(`/api/teams/${teamId}/mobilisation-tasks`),

    saveMobilisationTasks: (teamId: number, tasks: TeamTaskRow[]) =>
        api.put<{ data: TeamTaskRow[] }>(`/api/teams/${teamId}/mobilisation-tasks`, { tasks }),

    getTechnicalChecklist: (teamId: number) =>
        api.get<{ data: TeamTaskRow[] }>(`/api/teams/${teamId}/technical-checklist`),

    saveTechnicalChecklist: (teamId: number, tasks: TeamTaskRow[]) =>
        api.put<{ data: TeamTaskRow[] }>(`/api/teams/${teamId}/technical-checklist`, { tasks }),
}
